export const colors = {
  brand: {
    50: '#ECF8F8',
    100: '#06BCC1',
    200: '#06BCC1',
    300: '#06BCC1',
    400: '#06BCC1',
    500: '#06BCC1',
    600: '#03A2A7',
    700: '#03A2A7',
    800: '#03A2A7',
    900: '#03A2A7',
  },
  bg: {
    50: '#FCFCFF',
  },
  alt: {
    50: '#FF6666',
    100: '#FF6666',
    200: '#FF6666',
    300: '#FF6666',
    400: '#FF6666',
    500: '#FF6666',
    600: '#db4242',
    700: '#db4242',
    800: '#db4242',
    900: '#db4242',
  },
  text: {
    50: '#e2e3e7',
    100: '#918991',
    200: '#918991',
    300: '#918991',
    400: '#5F575F',
    500: '#5F575F',
    600: '#746c74',
    700: '#746c74',
    800: '#241E24',
    900: '#241E24',
  },
  border: {
    50: '#F2F4FA',
    100: 'rgba(145, 137, 145, 0.15)',
    200: 'rgba(145, 137, 145, 0.15)',
    300: '#e2e3e7',
    400: '#e2e3e7',
    500: '#e2e3e7',
    600: '#e2e3e7',
    700: '#e2e3e7',
    800: '#e2e3e7',
    900: '#e2e3e7',
  },
  error: {
    50: '#FFE8E8',
    100: '#FFE8E8',
    200: '#FFE8E8',
    300: '#e53e3e',
    400: '#e53e3e',
    500: '#e53e3e',
    600: '#FFC1C1',
    700: '#FFC1C1',
    800: '#CC3232',
    900: '#CC3232',
  },
};
